// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"48256b4c","447":"0cdeb877","828":"569514dc","967":"776399bb"}[chunkId] + ".chunk.js";
};